<template>
    <div>
    <section style="background-color: rgba(156, 179, 189, 0.3); padding: 40px;">
        <div style="text-align: center;">
        <h2 style="margin-bottom: 0; font-size: 40px; font-weight: bold;">{{ block.title }}</h2>
        <img src="/img/teal-line.svg" class="mb20 mt20"/>
    </div>
    <div class="fort-body">
        <div style="text-align: center;">
        <img :src="'https://news.spacesaver.com' + block.Image.url" class="news-image" v-if="block.Image"/>
        </div>
        <div v-html="block.body">

</div>
    </div>
</section>

   <divider v-if="block.BottomDivider" />
  </div>
  </template>
  
  <script>
  import Divider from "@/components/FortBuilder/Divider.vue";
  export default {
    name: "DeliverWIn",
    data() {
        return {
        anniversaries: [
            {
                time: "20",
                name: "Patterson Pope"
            },
            {
                time: "32",
                name: "Heritage Business Interiors"
            },
            {
                time: "36",
                name: "The Systemcenter Inc."
            },
            {
                time: "28",
                name: "Ergo Office Plus"
            },
            {
                time: "29",
                name: "STORAGELogic"
            }
        ]
        };
    },
    props: {
      block: {
        type: Object,
        required: true,
      },
    },
    components: {
        Divider,
    },
    methods: {
      
    },
  };
  </script>
  
  <style scoped>
.news-image{
    width: 80%!important;
    margin: 20px 0 40px;
  }
  @media all and (max-width: 1199px) {
    .news-image{
        width: 100%!important;
        margin: 20px 0 40px;
    }
  }
</style>















